import { styled } from '@mui/material';
import { VFlex } from '../../../components/FlexContainers';
import {
  SubTitle as StandardSubTitle,
  Title as StandardTitle,
} from '../../../components/Typography';

export const Root = styled(VFlex)``;

export const Title = styled(StandardTitle)`
  line-height: 30px;
  margin-bottom: 0px;
`;

export const SubTitle = styled(StandardSubTitle)`
  letter-spacing: 1px;
  line-height: normal;
  text-transform: uppercase;
  ${(props) => props.theme.breakpoints.down('md')}  {
    margin-bottom: 0px;
  }
`;
